/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Access_Denied_BodyInputs */

const en_auth_error_access_denied_body = /** @type {(inputs: Auth_Error_Access_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account is not in the rmf-demo group, so the demo is not available. To request access, ask a maintainer to add you to the GitLab group.`)
};

const fr_auth_error_access_denied_body = /** @type {(inputs: Auth_Error_Access_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte n'est pas dans le groupe rmf-demo, la démo n'est donc pas accessible. Pour demander l'accès, contactez un mainteneur du groupe GitLab.`)
};

const ms_sg2_auth_error_access_denied_body = /** @type {(inputs: Auth_Error_Access_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun anda bukan dalam kumpulan rmf-demo, jadi demo tidak tersedia. Untuk meminta akses, minta penyelenggara menambah anda ke kumpulan GitLab.`)
};

/**
* | output |
* | --- |
* | "Your account is not in the rmf-demo group, so the demo is not available. To request access, ask a maintainer to add you to the GitLab group." |
*
* @param {Auth_Error_Access_Denied_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const auth_error_access_denied_body = /** @type {((inputs?: Auth_Error_Access_Denied_BodyInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Access_Denied_BodyInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_error_access_denied_body(inputs)
	if (locale === "fr") return fr_auth_error_access_denied_body(inputs)
	return ms_sg2_auth_error_access_denied_body(inputs)
});